export const teleprompterKeys = {
  scripts: () => ['SCRIPTS'] as const,
  list: (scope: string) => ['SCRIPTS', { scope }] as const,
  script: (scriptId: string) => ['SCRIPT', scriptId] as const,
};
